function sliderAbout() {
    var swiper = new Swiper('.about .mySwiper', {
        slidesPerView: 1,
        spaceBetween: 15,
        effect: "fade",
        speed: 600,
        navigation: {
            nextEl: ".about .swiper-button-next",
            prevEl: ".about .swiper-button-prev",
        },
        pagination: {
            el: ".about .swiper-pagination",
            clickable: true
        },
    })
}

function sliderAdvantages() {
    var swiper = new Swiper('.advantages .mySwiper', {
        slidesPerView: 1,
        spaceBetween: 80,
        speed: 600,
        navigation: {
            nextEl: ".advantages .swiper-button-next",
            prevEl: ".advantages .swiper-button-prev",
        },
        breakpoints: {
            320: {
                spaceBetween: 20,
            },
            993: {
                spaceBetween: 40,
            },
            1201: {
                spaceBetween: 80,
            }
        }
    })
}

let SlidersArray = []
function sliderPlan() {
    $(".plan__item-slider").each(function(index, el) {
        $(el).attr("data-slider-id", `${index}`)
        SlidersArray[index] = new Swiper(`.plan__item-slider[data-slider-id="${index}"] .swiper`, {
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 600,
            navigation: {
                nextEl: `.plan__item-slider[data-slider-id="${index}"] .swiper-button-next`,
                prevEl: `.plan__item-slider[data-slider-id="${index}"] .swiper-button-prev`,
            },
            pagination: {
                el: `.plan__item-slider[data-slider-id="${index}"] .swiper-pagination`,
                clickable: true
            },
        })
    })
}

$(document).ready(function () {
  sliderAbout();
  sliderAdvantages();
  sliderPlan();

    // Fancybox
    Fancybox.bind("[data-fancybox]", {});

    // Tabs
    $(".tab").click(function () {
        let path = $(this).attr("data-tab-path")
        $(this).siblings(".tab").removeClass("tab--active")
        $(this).addClass("tab--active")

        $(this).parents(".tabs-inner").find(".tab__content").removeClass("tab__content--active")
        $(this).parents(".tabs-inner").find(`.tab__content[data-content-path="${path}"]`).addClass("tab__content--active")
    })

    // Accordion
    $(".item-show").on("click", function (e) {
        e.stopPropagation();

        const item = $(this).closest(".item");
        const container = item.parent();

        container.children(".item")
            .not(item)
            .removeClass("item--active")
            .find("> .item-hidden")
            .slideUp();

        item.toggleClass("item--active");
        item.children(".item-hidden").slideToggle();
    });

    // Hover
    function setActive($item) {
        $('.advantages2__item').removeClass('active');
        $item.addClass('active');
    }

    $('.advantages2__item').on('mouseenter', function () {
        if ($(window).width() >= 993) {
            setActive($(this));
        }
    });

    $('.advantages2__item').on('click', function () {
        if ($(window).width() <= 992) {
            setActive($(this));
        }
    });

    // Modal
    $("[data-modal]").click(function () {
        let modalId = $(this).attr("data-modal")

        openModal(modalId)
    })

    function openModal(modalId){
        $(`#${modalId}`).addClass("modal--active")
        $("body").addClass("fixed-body")
    }

    $(".modal").click(function () {
        closeModal()
    })

    $("._close-modal").click(function () {
        closeModal()
    })

    $(".modal__dialog").click(function (e) {
        e.stopPropagation()
    })

    function closeModal() {
        $('.modal--active video').each(function () {
            this.pause();
            this.currentTime = 0;
        });

        $('.modal').removeClass("modal--active")
        $("body").removeClass("fixed-body")
    }

})